import {Component, Input} from '@angular/core';
import {AbstractInjection} from '../../injections/injection/abstract-injection';

@Component({
    selector: 'vui-exception',
    templateUrl: './exception.component.html',
    styleUrls: ['./exception.component.scss']
})
export class ExceptionComponent extends AbstractInjection {
    @Input() public description: string;
    @Input() public title: string;
}
